import { DateTime } from "luxon";
import { DateOps } from "../../core/unavailability/adapters/dateOps";

function createDateOps(): DateOps {
  return {
    isValidUtcIso(date: string): boolean {
      return DateTime.fromISO(date, { zone: "utc" }).isValid;
    },
    isAfterOrEqual(firstDate: string, secondDate: string): boolean {
      const first = DateTime.fromISO(firstDate, { zone: "utc" });
      const second = DateTime.fromISO(secondDate, { zone: "utc" });
      return first.isValid && second.isValid && first >= second;
    },
  };
}

export { createDateOps };
